import { Mail, MailX, MailMinus } from "lucide-react";

const KIND = { new: "Bevestiging", moved: "Verplaatsing", cancelled: "Annulering", reminder: "Herinnering" };
const ROLE = { client: "klant", advisor: "adviseur" };
const ICON = { sent: [Mail, "text-[#0C6E6E]", "verstuurd"], failed: [MailX, "text-[#B0413E]", "mislukt"], skipped: [MailMinus, "text-[#B7791F]", "overgeslagen"] };

export function ApptEmailLog({ emails, testid }) {
  if (!emails?.length) return <p data-testid={testid} className="text-[11px] text-[#8994A3]">Nog geen e-mails verstuurd.</p>;
  return (
    <ul data-testid={testid} className="space-y-0.5">
      {emails.map((e, i) => {
        const [Icon, cls, label] = ICON[e.status] || ICON.failed;
        const when = new Date(e.at).toLocaleString("nl-NL", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
        return (
          <li key={i} data-testid={`${testid}-${i}`} className={`flex items-start gap-1.5 text-[11px] ${cls}`} title={e.to || e.reason}>
            <Icon className="h-3 w-3 mt-0.5 shrink-0" />
            <span>{KIND[e.kind] || e.kind} → {ROLE[e.role] || e.role}: {label}{e.status === "skipped" && e.reason ? ` (${e.reason})` : ""}{e.status === "failed" ? " — wordt niet automatisch opnieuw geprobeerd" : ""} · {when}</span>
          </li>
        );
      })}
    </ul>
  );
}
